




























































































































































































































































































































import {Component, mixins, Watch} from 'nuxt-property-decorator'

import {AppMixin, CategoryMixin} from '~/node_modules/sitis-nuxt/lib/mixins'
import PagePagination from '~/components/page/PagePagination.vue'
import AcuvueCard from '~/components/catalog/AcuvueCard.vue'
import Pagination from '~/components/Pagination.vue'
import InfoBalanceMyAcuvue from '~/components/catalog/InfoBalanceMyAcuvue.vue'
import ProductCard from '~/components/product/ProductCard.vue'
import ProductCardLoading from '~/components/catalog/ProductCardLoading.vue'
import SPage from '~/components/page/SPage.vue'
import FastBuyProduct from '~/components/catalog/FastBuyProduct.vue'
import FilterComponent from '@/pages/catalog/components/FilterComponent.vue'
import FilterMobileComponent from '@/pages/catalog/components/FilterMobileComponent.vue'
import ArticleCard from '@/pages/catalog/components/ArticleCard.vue'
import SelectedFilter from '@/pages/catalog/components/SelectedFilter.vue'
import ContactLinzCategory from '@/pages/catalog/components/ContactLinzCategory.vue'
import {ObserveVisibility} from 'vue-observe-visibility'
import {formatFilterCanonical, formatFilterMeta} from '~/helpers/meta'
import BannerCard from '~/components/catalog/BannerCard.vue'
import {getOgTitle} from "~/helpers/metaHelper";
import FilterPcContent from "~/components/catalog-new/FilterPcContent.vue";
import FilterMobileContent from "~/components/catalog-new/FilterMobileContent.vue";

@Component({
  async fetch(this: any): Promise<void> {
    await this.loadCategoryDetailed();
    await this.loadCategory(false);

    const currentRoute = (this.$route?.path || "").split("/f/")?.[0];
    const categoryUrl = this.category?.url || "";
    if (!categoryUrl) {
      let parentCategoryUrl: any = (this.$route?.path || "").split("/");
      parentCategoryUrl.splice(-1, 1);
      parentCategoryUrl = parentCategoryUrl.join("/");
      const parentCategory = (this.categoriesList || []).find((t: any) => t.url === parentCategoryUrl);
      if (!parentCategory) {
        this.$nuxt.context.error({ statusCode: 404, message: `Category not found` });
        return
      }

      this.$nuxt.context.redirect(301, parentCategoryUrl);
      return
    }
    if (currentRoute !== categoryUrl) {
      this.$nuxt.context.redirect(301, categoryUrl);
    }

    if (!process.client) {
      await this.callCategoriesCategoryView();
    }
  },

  asyncData: function (context): object {
    const host: string = context?.req?.headers?.host || window?.location.host || ''
    const pathMatch: string = context?.route?.params?.pathMatch || ''
    const pageSlug = (pathMatch.split('f/')?.[0] || '').split('/')?.[0] || ''
    if (!pageSlug) {
      context.error({statusCode: 404})
    }

    return {
      host
    }
  },
  head(this: CategoryPage) {
    const head: any = {
      title: '',
      meta: [],
      link: [],
    }

    // Заполнение title
    if (this.category) {
      const title = this.filterPages?.[0]?.seo?.title || this.filterInfo?.seo_title || this.category?.seo?.title || this.category?.metaTitle || ''
      head.title = title
      head.meta.push({
        name: 'og:title',
        hid: 'og:title',
        property: 'og:title',
        content: getOgTitle(title, this.$store.state.appState?.config)
      },)
    }

    // Заполнение description
    const description = this.filterPages?.[0]?.seo?.description || this.filterInfo?.seo_description || this.category?.seo?.description || this.category?.metaDescription || ''
    if (!!description) {
      head.meta.push({
        hid: 'metadescription',
        name: 'description',
        content: description
      })
      head.meta.push({
        name: 'og:description',
        hid: 'og:description',
        property: 'og:description',
        content: description
      })
    }

    // Заполнение keywords
    const keywords = this.filterPages?.[0]?.seo?.keywords || this.filterInfo?.seo_keywords || this.category?.seo?.keywords || this.category?.metaKeywords || ''
    if (!!keywords) {
      head.meta.push({
        name: 'keywords',
        content: keywords
      })
    }

    head.link.push({
      rel: 'canonical',
      href: this.linkCanonical
    })
    if (Boolean(this.isMultiVariantItems)) {
      head.meta.push(
        {
          name: 'robots',
          content: `noindex`
        }
      )
    }

    if ((this.products || []).length <= 0) {
      head.meta.push({name: "robots", content: "noindex"});
    }

    return head
  },

  key(route) {
    return route.path
  },

  components: {
    PagePagination,
    SPage,
    Pagination,
    ProductCard,
    SelectedFilter,
    ArticleCard,
    AcuvueCard,
    FilterComponent,
    FilterPcContent,
    FilterMobileComponent,
    ContactLinzCategory,
    InfoBalanceMyAcuvue,
    FastBuyProduct,
    BannerCard,
    ProductCardLoading,
    FilterMobileContent,

    FilterSelected: () => import('~/components/catalog-new/FilterSelected.vue')
  },

  directives: {
    ObserveVisibility,
  },

  beforeRouteEnter(to, from, next) {
    if (to.path === from.path) {
      next()

      return null
    }

    next((vm: any) => {
      vm.routeToTop()
    })
  },

  async mounted(this: CategoryPage) {
    this.routeToTop()
    this.bannerList = await this.getBannersLists()
    this.categoryGridView = localStorage?.view || 'max'
    // Устоновка изначально запущенной станицы
    // для функционала загрузки предедущих товаров
    const startPage = this.$route?.query?.page || '0'
    this.startCatalogPage = +startPage;

    this.setEcommerceImpressions();
    await this.callCategoriesCategoryView();
  },

  beforeDestroy(this: CategoryPage) {
    sessionStorage.setItem('catalog-header-title', this.sPageTitle)
  },

  computed: {
    setBreadcrumbs(this: CategoryPage) {
      let breadcrumbs = [...this.breadcrumbs];

      if (this.filterPages.length) {
        breadcrumbs = [];

        breadcrumbs.push(
          {path: "/", title: 'Главная'},
          {path: `/catalog/${this.category.slug}`, title: this.category.name},
          {
            path: this.filterPages?.[0]?.url,
            title: this.filterPages?.[0]?.title
          }
        )
      }

      return breadcrumbs
    },

    loading: function () {
      return false
      // return Boolean(this?.filtersLoading?.update || this?.filtersLoading?.get)
    },

    pageTitle: function (this: CategoryPage) {
      if (Boolean(this.filterInfo?.h1)) {
        let singleMaxCpunt = 0;
        const count = Object.keys((this.selectedFilters || {})).reduce((val, item) => {
          const _count = Object.keys((this.selectedFilters?.[item] || {})).length || 0;
          if (_count > singleMaxCpunt) {
            singleMaxCpunt = _count;
          }
          return val + 1
        }, 0);
        if (count <= 2 && singleMaxCpunt <= 1) {
          return this.filterInfo?.h1
        }
        return this?.category?.title
      }
      return this.filterPages?.[0]?.title || this?.category?.title
    },

    titleMetaCaregory: function (this: CategoryPage) {
      const activeFilter = {...this.selectedFilters}
      const category = this.category?.slug
      const string = formatFilterMeta(
        activeFilter,
        category,
        this.appCfg,
        this.filters
      )

      if (!string || this.filterPages?.[0]) {
        return (
          this.filterPages?.[0]?.seo?.title || ''
        )
      }

      const messageFirstPart = `Купить ${this.category?.name}`

      return `${messageFirstPart} ${string}`
    },
    desctiptionMetaCaregory: function (this: CategoryPage) {
      const activeFilter = {...this.selectedFilters}
      const category = this.category?.slug

      if (this.filterPages?.[0]) {
        return (
          this.filterPages?.[0]?.seo?.description ||
          this?.category?.seo?.description ||
          ''
        )
      }

      return this.filterInfo?.seo_description || this.category?.seo?.description || `Покупайте ${this.category?.name}`
    },

    faqBlockValue: function (this: CategoryPage) {
      return {
        categoryId: this.category?.id,
        filterPageId: this.filterPages?.[0]?.id,
        useApi: true
      }
    },


    cmsPageId: function () {
      return Number.parseFloat(this.$store.state.appState?.vars?.['Шаблон для посадочных страниц'] || '0')
    },
    defaultPerPage: function () {
      return 30
    },

    cmsBottomText: function (this: CategoryPage) {
      return this.filterPages?.[0]?.bottomText
    },
    categoryDescriptionBottom: function (this: CategoryPage) {
      return this.category?.description || ""
    },

    isUserHasMyAcuvue: function () {
      return Object.keys(this.$store?.state?.myacuvue?.profile)?.length > 0;
    },
  },
})

export default class CategoryPage extends mixins(CategoryMixin, AppMixin) {
  $api: any
  $cookies: any
  $yandexCommerce: any

  isOpenFilterContainer(index: number): boolean {
    return this.filterContainers.includes(index)
  }

  enough = false
  listGridMode = true
  accordionMode = false
  prevProductSlug = null
  categoryGridView = 'max'
  sPageTitle: string = ''
  host: string = ''
  head: any = {
    title: '',
    meta: [],
  }
  categoryDescription: string = ''
  filterContainers: number[] = []
  fastBuyProduct: number = 0
  startCatalogPage: number = 0
  nextLoadedPages: number = 0
  bannerList: any = []

  // Логика ленивой загрузки товаров
  isLoadedLazyLoadProducts: boolean = false
  timeOutLazyLoadProducts: any = null
  // -------------------------------

  timeOutLoadProductForScroll: any = null

  parseFilter(dataFilters: any) {
    if (typeof dataFilters === 'undefined') {
      return false
    }
    const fpath = dataFilters.split('/')
    let link: boolean = false
    fpath.forEach(function (element: any) {
      if ((element.split('=')[1]).split(',').length > 1) {
        link = true
      }
    })
    return link
  }

  @Watch('loadersMap', {deep: true})
  async onChangeLoadProduct() {
    if (this.loadersMap.filters || this.loadersMap.products) {
      return null
    }

    // Если серверный рединг, отменяем функцию
    if (this.$isServer) {
      return null
    }

    await setTimeout(() => {
    }, 500)

    const loadPrevProducts = this.$cookies.get('load-prev-products')
    if (loadPrevProducts) {
      this.onScrollLoadMoreBack(loadPrevProducts)

      return null
    }

    // Ищем, есть ли ID скролируемого продукта
    const scrollToProductId = this.$cookies.get('scroll-to-product-id')
    if (!scrollToProductId) {
      return null
    }

    // Ищем, нашелся ли такой элемент по ID
    const element = document.getElementById(`product-${scrollToProductId}`)
    if (!element) {
      return null
    }

    // Удаляем элемент
    this.$cookies.remove('scroll-to-product-id')

    // Вычесляем позицю и делаем скрол к элементу
    const container = document.body
    const offsetTop = element.offsetTop
    const offsetHeader = Boolean(window.innerWidth < 1000) ? 80 : 160 //80 - отсуп мобильный; 160 - отступ ПК
    window.scrollTo({
      top: (offsetTop - offsetHeader)
    })
  }

  @Watch('products', {deep: true})
  watchProductsLenght () {
    this.setEcommerceImpressions();
  }

  @Watch('category', {deep: true})
  async watchCategory () {
    if (process.client) {
      await this.callCategoriesCategoryView();
    }
  }

  onScrollLoadMoreBack(loadPrevProducts: any) {
    this.$cookies.remove('load-prev-products')

    const element = document.getElementById(`product-${loadPrevProducts.productId}`)
    const container = document.body
    const offsetTop = element?.offsetTop || 0

    window.scrollTo({
      top: (offsetTop - loadPrevProducts?.offsetTop)
    })
  }

  get extensions(): string[] {
    return ['promotions', 'customDataFields', 'short_characteristics', 'characteristics']
  }

  /** Это пример переопределения опций сортировки */
  get sortOptions() {
    return [
      {
        id: 'default',
        type: 'string',
        value: 'По популярности',
      },
      {
        id: 'price',
        type: 'string',
        value: 'Сначала дешёвые',
      },
      {
        id: '-price',
        type: 'string',
        value: 'Сначала дорогие',
      },
      {
        id: 'name',
        type: 'string',
        value: 'По алфавиту',
      },
      {
        id: '-created_at',
        type: 'string',
        value: 'По новизне',
      },
    ]
  }

  get listProduct() {
    let products = [...this.products]

    products.splice(8, 0, products[0])

    return products
  }

  get showButtonLoadPrevProducts() {
    const pagination = this.pagination
    const productCount = (this.products || []).length

    return Boolean(pagination.page > 1 && this.startCatalogPage > 1)
  }

  get titleMetaCaregory() {
    const activeFilter = {...this.selectedFilters}
    const category = this.category?.slug
    const string = formatFilterMeta(activeFilter, category, this.appCfg, this.filters)

    if (!string || this.filterPages?.[0]) {
      return this.filterPages?.[0]?.seo?.title || this.category?.metaTitle || ''
    }
    if (this.filterInfo?.seo_title) {
      return this.filterInfo?.seo_title
    }

    const messageFirstPart = Boolean(category === 'linzy') ? 'Купить контактные линзы' : 'Купить'

    return `${messageFirstPart} ${string}`
  }

  get desctiptionMetaCaregory() {
    const activeFilter = {...this.selectedFilters}
    const category = this.category?.slug
    const string = formatFilterMeta(activeFilter, category, this.appCfg, this.filters)

    if (!string || this.filterPages?.[0]) {
      return this.filterPages?.[0]?.seo?.description || this.category?.metaDescription || ''
    }
    if (this.filterInfo?.seo_description) {
      return this.filterInfo?.seo_description
    }

    const messageFirstPart = Boolean(category === 'linzy') ? 'Покупайте контактные линзы' : 'Покупайте'
    const messageLastPart = Boolean(category === 'linzy') ?
      'Большой выбор линз для глаз в салонах сети “Очки для Вас” с доставкой' :
      Boolean(category === 'opravy') ?
        'Большой выбор очков в салонах сети “Очки для Вас” с доставкой' :
        'Большой выбор темных очков от солнца в салонах сети “Очки для Вас” с доставкой'

    return `${messageFirstPart} ${string}. ${messageLastPart}`
  }

  get isMultiVariantItems() {
    const selectedFilters = {...(this.selectedFilters || {})}

    let isMulti = false
    Object.keys(selectedFilters).map((key) => {
      const filter = selectedFilters[key]

      if (Object.keys(filter).length > 1) {
        isMulti = true
      }
    })

    return isMulti
  }

  get linkCanonical() {
    const basePath = this.host
    const routePath = this.routerParams.path

    const activeFilter = {...this.selectedFilters}
    const filterCanonical = formatFilterCanonical(activeFilter, this.filters)
    if (filterCanonical && filterCanonical.length !== 0) {
      const sortFilterCanonical = (this.$route?.path || '').split('/f/')?.[1] || '';
      return `https://${basePath}${routePath}/f/${sortFilterCanonical}`
    }

    return `https://${basePath}${routePath}`
  }

  get isVisibleBlockLazyLoadProducts() {
    return Boolean(+this.pageCount > +this.pagination?.page)
  }

  get shortDescription () {
    return this.category?.shortDescription || ""
  }

  get isSuveniry () {
    return this.category?.slug === 'suveniry'
  }

  get isLoadingProducts () {
    return this.loadersMap.products || this.loadersMap.product || this.loadersMap.category
  }

  onToggleFilterContainer(index: number): void {
    if (this.isOpenFilterContainer(index)) {
      const idx = this.filterContainers.findIndex((i) => i === index)
      if (idx > -1) {
        this.filterContainers.splice(idx, 1)
      }
    } else {
      this.filterContainers.push(index)
    }
  }

  onChangeView(view: string): void {
    if (localStorage.view === 'view') {
      return
    }
    this.categoryGridView = view
    localStorage.view = view
  }

  loadPrevProducts(): void {
    const firstProductId = this.products?.[0]?.id || 0
    const element = document.getElementById(`product-${firstProductId}`)
    const container = document.body
    const {top} = element?.getBoundingClientRect() || {}

    this.$cookies.set('load-prev-products', JSON.stringify({
      productId: firstProductId,
      offsetTop: top
    }))

    this.setProductsLoadMode('more-back')
    this.updatePageQuery({page: this.startCatalogPage - 1})

    this.startCatalogPage = this.startCatalogPage - 1
  }

  routeToTop() {
    if (!process.client) {
      return null
    }

    setTimeout(() => {
      var scrollTop = window?.pageYOffset || document?.body?.scrollTop || 0

      if (scrollTop <= 140) {
        return null
      }

      const element = document.getElementById('products-container') || document.body

      this.$smoothScroll({
        scrollTo: element,
        offset: -100,
        updateHistory: false
      })
    }, 100)
  }

  isShowAcuvueCard(indexCard: number) {
    const isMobile = Boolean(this.$nuxt.$isServer) ? false : Boolean((window?.innerWidth || 0) <= 640)
    const indexCardVisible = isMobile ? 3 : 8

    const myAcuvue = this.$store.state?.myacuvue?.profile || {}

    // Если стоит запрет на использование MyAcuvue
    if (!Boolean(process.env.myAcuvueIncluded || false)) {
      return false
    }

    if (indexCard !== indexCardVisible) {
      return false
    }

    if (Object.keys(myAcuvue).length > 0) {
      return false
    }

    if (
      !this.selectedFilters?.brand?.acuvue &&
      !this.selectedFilters?.manufacturer?.['johnson-johnson']
    ) {
      return false
    }

    return true
  }

  // Логика ленивой загрузки товаров
  async eventLazyLoadProducts(isVisible: boolean): Promise<void> {
    if (this.isLoadedLazyLoadProducts || !isVisible) {
      return
    }
    clearTimeout(this.timeOutLazyLoadProducts)

    this.isLoadedLazyLoadProducts = true
    this.timeOutLazyLoadProducts = setTimeout(async () => {
      await this.loadLazyLoadProducts()
    }, 1000)
  }

  async loadLazyLoadProducts(): Promise<void> {
    const blockLazyLoadProducts: any = this.$refs.blockLazyLoadProducts
    const targetPosition = {
      top: window.pageYOffset + blockLazyLoadProducts.getBoundingClientRect().top,
      left: window.pageXOffset + blockLazyLoadProducts.getBoundingClientRect().left,
      right: window.pageXOffset + blockLazyLoadProducts.getBoundingClientRect().right,
      bottom: window.pageYOffset + blockLazyLoadProducts.getBoundingClientRect().bottom
    }
    const windowPosition = {
      top: window.pageYOffset,
      left: window.pageXOffset,
      right: window.pageXOffset + document.documentElement.clientWidth,
      bottom: window.pageYOffset + document.documentElement.clientHeight
    }

    // Если тригер находиться вне зоны видимости
    const elementVisible = Boolean(targetPosition.bottom > windowPosition.top && targetPosition.top < windowPosition.bottom && targetPosition.right > windowPosition.left && targetPosition.left < windowPosition.right)
    if (!elementVisible) {
      this.isLoadedLazyLoadProducts = false
      return
    }

    await this.loadMoreProductsWithoutFilters()

    // Если последняя карточка находиться вне зоны видимости
    const lastProduct: any = [...this.products].pop()
    const elementLastProduct: any = document.getElementById(`product-${lastProduct?.id}`)
    const elementLastProductSizes = elementLastProduct.getBoundingClientRect()
    const elementLastProductPosition = {
      top: window.pageYOffset + elementLastProductSizes.top,
      left: window.pageXOffset + elementLastProductSizes.left,
      right: window.pageXOffset + elementLastProductSizes.right,
      bottom: window.pageYOffset + elementLastProductSizes.bottom
    }
    const elementLastProductVisibled = Boolean(elementLastProductPosition.bottom > windowPosition.top && elementLastProductPosition.top < windowPosition.bottom && elementLastProductPosition.right > windowPosition.left && elementLastProductPosition.left < windowPosition.right)
    if (!elementLastProductVisibled) {
      window.scrollTo({
        top: elementLastProductPosition.top
      })
    }

    this.isLoadedLazyLoadProducts = false
  }

  // _______________________________

  async loadMoreNextProducts(isVisible: any): Promise<void> {
    // if (this.loadersMap.filters || this.loadersMap.products || this.loadersMap.updateFilters) {
    //   return
    // }
    //
    // if (!isVisible) {
    //   return
    // }
    //
    // this.nextLoadedPages = this.nextLoadedPages + 1;
    //
    // if (this.nextLoadedPages >= 10) {
    //   return
    // }
    //
    // await this.loadMoreProducts();
  }

  async getNextProducts(): Promise<void> {
    this.nextLoadedPages = this.nextLoadedPages + 1

    if (this.nextLoadedPages >= 10 && false) {
      return
    }

    await this.loadMoreProductsWithoutFilters()
  }

  async getBannersLists() {
    const currentPage = this.$route.fullPath

    const res = await this.$api.agent.transport.get(`banners/get?places[]=products_list_item&url=${currentPage}`)
      .then((res: any) => {
        return res.data
      })
      .catch((err: any) => {
        return {}
      })

    if (Object.keys(res).length) {
      return res?.products_list_item || []
    }
    return {}
  }

  async _onChangePage(page: number): Promise<void> {
    this.nextLoadedPages = 0
    this.onChangePage(page)
  }

  async _onChangePerPage(perPage: number): Promise<void> {
    this.nextLoadedPages = 0
    this.onChangePerPage(perPage)
  }

  async _onChangeSort(sortValue: any): Promise<void> {
    this.startCatalogPage = this.pagination.page
    this.onChangeSort(sortValue)
  }


  setEcommerceImpressions () {
    const products = [...(this.products || [])].reverse().splice(0, this.pagination.perPage);
    if (products.length <= 0) {
      return
    }
    this.$yandexCommerce('impressions', products);
  }


  async callCategoriesCategoryView(this: CategoryPage): Promise<void> {
    if (!this.category?.id || process.server) {
      return
    }
    await this.$store.dispatch("mindbox/categoriesCategoryView", {
      category_id: this.category?.id
    });
  }





  get isShowFilterSelected() {
    const isSelectedFilters = Object.keys(this.selectedFilters || {}).length > 0;
    return isSelectedFilters
  }
  timeOutUpdateProducts: any = null;
  async onFastUpdateFilter (filters: any): Promise<void> {
    clearTimeout(this.timeOutUpdateProducts);
    await this.getUpdateFilters(filters);
    await this.onRequestUpdateProducts(filters);
  }
  async onRequestUpdateFilter (filters: any): Promise<void> {
    clearTimeout(this.timeOutUpdateProducts);
    this.timeOutUpdateProducts = setTimeout(async () => {
      await this.getUpdateFilters(filters);
      await this.onRequestUpdateProducts(filters);
    }, 500);
  }
  async onRequestUpdateProducts (filters: any): Promise<void> {
    await this.updateProductsWithoutFilters(filters);
    await this.getFilterPagesWithoutFilters();
  }
}
